export default function ownerDocument(node) {
  return (node === null || node === void 0 ? void 0 : node.ownerDocument) || document;
}
//# sourceMappingURL=ownerDocument.mjs.map